import {helpers} from '@/ft-vue-core'

const {loadRetryOrPrompt} = helpers

export function lazyLoading (name) {
  if (name.match(/^[@/]+/)) {
    name = name.replace(/^[@/]+/, '')
    return () => loadRetryOrPrompt(() => import(`@/${name}.vue`), 2, 1000)
  } else {
    return () => loadRetryOrPrompt(() => import(`@/components/${name}.vue`), 2, 1000)
  }
}
